// extracted by mini-css-extract-plugin
export var auditCard = "styles-module--audit-card--7cbcf";
export var buttonsContainer = "styles-module--buttonsContainer--cb307";
export var circle = "styles-module--circle--a780c";
export var confirmed = "styles-module--confirmed--86911";
export var contentBox = "styles-module--contentBox--d72c9";
export var draftItems = "styles-module--draftItems--e596e";
export var found = "styles-module--found--f22f9";
export var imageAndTitle = "styles-module--imageAndTitle--7bbb3";
export var progressBar = "styles-module--progressBar--cb20c";
export var textContainer = "styles-module--textContainer--2d866";
export var titleIconContainer = "styles-module--titleIconContainer--eb8f3";
export var totalItems = "styles-module--totalItems--ab61f";